import React from "react";
import { MdNearbyError } from "react-icons/md";
const NoDataFound = () => {
  return (
    <div className="row">
      <div className="alert alert-danger text-center" role="alert">
        <MdNearbyError /> No Data Found
      </div>
    </div>
  );
};
export default NoDataFound;
